import ReadMore from './class/ReadMore';

window.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.text-read-more').forEach(function(element){
        new ReadMore(element, element.dataset.maxHeight);
    });
});



// WEBPACK FOOTER //
// ./scripts/readMore.js